import { ApplicationConfig, LOCALE_ID, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, Routes } from '@angular/router';

import { registerLocaleData } from '@angular/common';
import localePl from '@angular/common/locales/pl';
registerLocaleData(localePl);

import { AppRoutingModule } from './app-routing.module';
import { ClientsListComponent } from './clients/clients-list/clients-list.component';
import { InstancesListComponent } from './instances/instances-list/instances-list.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './_infrastructure/auth-interceptor';
import { loaderInterceptor } from './_infrastructure/loader-interceptor';
import { InstanceDetailsComponent } from './instances/instance-details/instance-details';
import { ClientDetailsComponent } from './clients/client-details/client-details.component';
import { errorsInterceptor } from './_infrastructure/errors-interceptor';
import { provideNativeDateAdapter } from '@angular/material/core';

const routes: Routes = [
  //{ path: '', redirectTo: 'clients', pathMatch: 'full' },
  { path: 'clients', component: ClientsListComponent },
  { path: 'clients/:id', component: ClientDetailsComponent },
  { path: 'instances', component: InstancesListComponent },
  { path: 'instances/:id', component: InstanceDetailsComponent }
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideNativeDateAdapter(),
    { provide: LOCALE_ID, useValue: 'pl' },
    provideHttpClient(
      withInterceptors([authInterceptor, loaderInterceptor, errorsInterceptor])
    )
  ]
};
